import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { LoginForm } from '../components/login-form.js';
import { clearStaffSessionCache } from '../hooks/use-staff-session.js';

/* Rota de login (pública). Após sucesso, descarta o cache da sessão (o `ensureQueryData` do
   guard buscará /me fresco → evita servir um `null` cacheado e cair em loop de login) e navega
   ao painel; o guard de `authenticated` cuida do caso inverso (sem cookie → volta pra cá). */
export function LoginRoute() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return (
    <LoginForm
      onSuccess={() => {
        clearStaffSessionCache(queryClient);
        navigate({ to: '/dashboard' }).catch(() => undefined);
      }}
    />
  );
}
